<template lang="pug">
.flex.justify-center
  .pb-48.z-300
    
    .rounded-12.shadow-bg.bg-white.max-w-1616.px-80.pt-60.pb-80.text-left
      .titleDemo Button 
      .sub Normal_Pri
      .flex
        Button.w-168.m-20.mb-0( @buttonClick="AAA()" type="" text="Button" )
        Button.w-168.m-20.mb-0( @buttonClick="AAA()" type="" :disable="true" text="Button")
        
      .sub Normal_Sec
      .flex
        Button.w-168.m-20.mb-0( @buttonClick="AAA()" type="borderSolid" text="Button")
        Button.w-168.m-20.mb-0( @buttonClick="AAA()" type="borderSolid" :disable="true" text="Button")
      .sub Small_Pri
      .flex
        Button.w-104.m-20.mb-0( @buttonClick="AAA()" :height="24" textSize="12" type="" text="Button")
        Button.w-104.m-20.mb-0( @buttonClick="AAA()" :height="24" textSize="12" type="" :disable="true" text="Button")
      .sub Small_Sec
      .flex
        Button.w-104.m-20.mb-0( @buttonClick="AAA()" :height="24" textSize="12" type="borderSolid" text="Button" )
        Button.w-104.m-20.mb-0( @buttonClick="AAA()" :height="24" textSize="12" type="borderSolid" :disable="true" text="Button" )
      .sub Create New
      .flex
        .w-222.h-60.rounded-30.shadow-card.bg-white.flex.items-center.cursor-pointer.ml-28.mt-6.group(
          class="hover:bg-main-deep hover:text-white")
            .w-48.h-48.rounded-50.bg-main-0.ml-6.mr-30.flex.justify-center.items-center.rotate-45.transform(class="group-hover:bg-main-deep group-hover:ease-in-out")
              iCon.h-28.text-white(:iconClass="'close'" type="svg" )
            .text-20 Create New
        .w-222.h-60.rounded-30.shadow-card.bg-white.flex.items-center.cursor-not-allowed.ml-28.mt-6.group()
            .w-48.h-48.rounded-50.bg-main-disable.ml-6.mr-30.flex.justify-center.items-center.rotate-45.transform()
              iCon.h-28.text-white(:iconClass="'close'" type="svg" )
            .text-20.text-grey-97 Create New
      .sub Fliter Tab
      .flex
      FilterTab(:itemList="filterList" @deleteFilter="deleteFilter" :clearAll="true")
      
      //- .titleDemo Timepicker
      //- .sub value : {{valueDatePicker}}
      //- DatePicker.h-32( v-model="valueDatePicker" :type="'time'" :show-hour="true" 
      //- :show-minute="true" :show-second="false" 
      //- format="HH:MM"
      //- value-type="format"
      //- placeholder="HH:MM ") 
        //- template(#header)
        //-   div 123456


      .titleDemo Timepicker
      .sub value : {{valueDatePicker}}
      .flex
        TimePicker.w-220.mr-10(format="HH:mm" @changeTime="changeTime" :valueDatePicker="valueDatePicker" )
        TimePicker.w-220.mr-10(format="HH:mm" @changeTime="changeTime" :valueDatePicker="valueDatePickerError" :isDisabled="true")
        TimePicker.w-220(format="HH:mm" @changeTime="changeTime" :valueDatePicker="valueDatePicker" :error="'this is error message this is error message'")



      .titleDemo Radio Button 
      .sub value : {{radioValue}}
      .flex
      Radiobox(:options="packTypeOptions" :value="radioValue" label="radio title"  @changeValue="updateRadio"  displayColumn="h")
      //label要標示出來不同
      .sub value : {{radioValue2}}
      Radiobox(:options="packTypeOptions"   :value="radioValue2" label="radio title2"  @changeValue="updateRadio2")
      .titleDemo Checkbox 
      .sub {{check}}
      Checkbox.mt-20(:options="severityList" displayColumn="h" label="checkbox title" :value="check" @changeValue="isCheck")
      .sub {{check2}}
      Checkbox.mt-20(:options="severityList" displayColumn="" label="checkbox title2" :value="check2" @changeValue="isCheck2")
      
      
      
      .titleDemo Progress
      .sub max : {{progressMax}} value : {{progressValue}}
        .flex.mt-10
          Button.w-104.mr-10( @buttonClick="addProgress(true)" :height="24" textSize="12" type="smallSub" text="Add" )
          Button.w-104( @buttonClick="addProgress(false)" :height="24" textSize="12" type="smallSub" text="Min" )
      Progress.w-400(:max="progressMax" :value="progressValue")
      .titleDemo Input
      .sub value : {{inputVal}} 
      .sub maxLength : 5
      .flex
        Input.mr-10(type="text" :maxLength="'5'"  @onKey="onKey" v-model="inputVal" :placeholder="'I am placeholder'" 
        :isDisabled="false" @onblur="toblur" )
        Input.mr-10(type="text" :maxLength="'5'"  @onKey="onKey" v-model="inputVal2"  :placeholder="'I am placeholder'"
        :isDisabled="true" @onblur="toblur" )
        Input.mr-10(type="text" :maxLength="'5'"  @onKey="onKey" v-model="inputVal3"  
        :isDisabled="false" @onblur="toblur" :error="'this is error message this is error message'")
      .titleDemo Dropdown
      .sub value : {{selectDefault}}
      .flex
        Select.w-220.mr-10(
          :defaultSelectedValue="selectDefault" 
          :optionArr="selectOption" 
          :required="true"
          :showCheckIcon="true"
          @onClick="selectClick"
          @onblur="toblur" 
          name="demoSelect"
          :placeholder="'I am placeholder'")
        Select.w-220.mr-10(
          :defaultSelectedValue="selectDefault2" 
          :optionArr="selectOption" 
          :isDisable='true'
          @onClick="selectClick"
          @onblur="toblur" 
          name="demoSelect3"
          :placeholder="'I am placeholder'")
        Select.w-220.mr-10(
          :defaultSelectedValue="selectDefault2" 
          :optionArr="selectOption" 
          :required="true"
          :error="'this is error message'"
          @onClick="selectClick"
          @onblur="toblur" 
          name="demoSelect2")
      .sub Dropdown Checkbox
      .sub {{selectCheckBoxValue}}
      .flex
        InputSelect.w-220.mr-10(
          :defaultSelectedValue="selectCheckBoxValue" 
          :placeholder="'Dropdown_Checkbox'"
          :optionArr="selectCheckBoxOption" 
          @onClick="categorySearch")
        InputSelect.w-220.mr-10(
          :isDisable='true'
          :defaultSelectedValue="selectCheckBoxValue" 
          :placeholder="'Dropdown_Checkbox'"
          :optionArr="selectCheckBoxOption" 
          @onClick="categorySearch")
        InputSelect.w-220(
          :error="'this is error message'"
          :defaultSelectedValue="selectCheckBoxValue" 
          :optionArr="selectCheckBoxOption" 
          :required="true"
          @onClick="categorySearch")
      FilterTab(:itemList="selectCheckBoxValue" 
      @deleteFilter="deleteSelectCheckBoxValue" :clearAll="true")
      .titleDemo Textarea
      .sub value : {{demoTextarea}}
      .flex
        Textarea.mr-10( v-model="demoTextarea" :required="true" width="220px" :placeholder="'Textarea'"
        :isDisabled="false" @onblur="toblur" :maxLength="50" name="demoTextarea")
        Textarea.mr-10( v-model="demoTextarea2" :required="true" width="220px" 
        :isDisabled="true" @onblur="toblur" :maxLength="50" name="demoTextarea" :placeholder="'Textarea'")
        Textarea.mr-10( v-model="demoTextarea2" :required="true" width="220px" :error="'this is error message'"
        :isDisabled="false" @onblur="toblur" :maxLength="50" name="demoTextarea")
      .titleDemo Icon
      .flex.flex-row.flex-wrap
        .card.px-10.mr-10.mb-10.flex.justify-center.items-center(v-for="(e,i) in iconList")
          .sub name : {{e}}
          iCon.h-28.max-w-40.inline-block.text-main-0.ml-20.text-black(:iconClass="e" type="svg" )
      .titleDemo Card
      .card.p-20.w-400.h-400
      .titleDemo Pagination
      .sub currentPage : {{meta.current}}
      .flex.items-center
        .sub total_page : 
        Input.w-40.mx-10(type="text" :maxLength="'5'" @onKey="onPagination" v-model="meta.total_page" )
      Pagination.mt-28(
        :totalPage="meta.total_page" 
        :nowPage="meta.current" 
        :range="range" 
        @changePage="changePage" 
        position="left")
      .titleDemo Progress Tracker
      .sub value : 
      Stepper.mt-72.mb-104.w-496(@changeStep="changeStep" :currentStep="currentStep")
      


</template>

<script>
import moment from "moment";

import Button from "@/components/Button.vue";
import Checkbox from "@/components/Checkbox.vue";
import Radiobox from "@/components/Radiobox.vue";
import Input from "@/components/Input.vue";
import Select from "@/components/Select.vue";
import Textarea from "@/components/Textarea.vue";
import Progress from "@/components/Progress.vue";

import FilterTab from "@/components/FilterTab.vue";
import InputSelect from "@/components/InputSelect.vue";
import Pagination from "@/components/Pagination.vue";
import Stepper from "@/components/Stepper.vue";
// import VueTimepicker from 'vue2-timepicker'
import TimePicker from "@/components/TimePicker.vue";

export default {
  name: "Ui",
  components: {
    Button,
    Checkbox,
    Radiobox,
    Input,
    Select,
    Textarea,
    Progress,
    FilterTab,
    InputSelect,
    Pagination,
    Stepper,
    TimePicker
  },
  data() {
    return {
      currentStep: 0,
      meta: {
        //Pagination data
        current: 1,
        total: 60,
        total_page: 12
      },
      check: ["severity_high"],
      check2: ["severity_medium"],
      radioValue: "value_2",
      radioValue2: "value_3",
      inputVal: "",
      inputVal2: "",
      inputVal3: "",
      selectOption: [
        { id: "op1", name: "Option 1", disabled: false },
        { id: "op2", name: "Option 2", disabled: false },
        { id: "op3", name: "Option 3", disabled: true },
        { id: "op4", name: "Option 4", disabled: false }
      ],
      selectDefault: undefined, //傳進來是物件，但要預先給字串或者undefined
      selectDefault2: undefined,
      demoTextarea: "",
      demoTextarea2: "",
      iconList: [
        "ap_icon_language",
        "ap_Icon_NPS",
        "ap_Icon_Setting",
        "beta-mark",
        "check",
        "close",
        "dropdown",
        "globe",
        "Ico_Download",
        "ico_Drawer",
        "ico_Home",
        "ico_Launch",
        "ico_Maximize",
        "ico_Minimize",
        "ico_Next",
        "ico_NPS",
        "ico_Open",
        "Ico_Processing",
        "Ico_Settings",
        "ico_System back",
        "Ico_Update History",
        "ico_Update",
        "Icon_hit",
        "icon-search",
        "ico-processing",
        "logo",
        "search",
        "user",
        "asus_icon",
        "Ico_Beta",
        "imaker-ico-check",
        "ico_Close",
        "Ico_Check"
      ],
      progressMax: 40,
      progressValue: 3,
      filterList: [
        {
          name: "Chipset",
          id: "Chipset",
          disabled: false,
          icon: "ico_Close"
        },
        {
          name: "Graphics",
          id: "Graphics",
          disabled: false,
          icon: "ico_Close"
        },
        {
          name: "Bluetooth",
          id: "Bluetooth",
          disabled: false,
          icon: "ico_Close"
        },
        {
          name: "Pointing Device",
          id: "Pointing Device",
          disabled: false,
          icon: "ico_Close"
        },
        {
          name: "Software and Utility",
          id: "Software and Utility",
          disabled: true,
          icon: "ico_Close"
        }
      ],
      selectCheckBoxOption: [
        { id: "op1", name: "Option 1", disabled: false },
        { id: "op2", name: "Option 2", disabled: false },
        { id: "op3", name: "Option 3", disabled: true },
        { id: "op4", name: "Option 4", disabled: false },
        { id: "op5", name: "Option 5", disabled: false },
        { id: "op6", name: "Option 6", disabled: false }
      ],
      selectCheckBoxValue: undefined,
      valueDatePicker: undefined,
      valueDatePickerError: undefined
    };
  },
  computed: {
    range() {
      return this.meta.total_page < 5 ? this.meta.total_page : 5;
      // return this.meta.total_page;
    },
    severityList() {
      //
      return [
        {
          name: "High",
          val: "severity_high",
          disabled: false
        },
        {
          name: "Recommend",
          val: "severity_medium",
          disabled: true
        },
        {
          name: "Optional",
          val: "severity_low",
          disabled: false
        }
      ];
    },
    packTypeOptions() {
      return [
        {
          name: "Radio Button 1",
          val: "value_1",
          disabled: false
        },
        {
          name: "Radio Button 2",
          val: "value_2",
          disabled: false
        },
        {
          name: "Radio Button 3",
          val: "value_3",
          disabled: true
        },
        {
          name: "Radio Button 4",
          val: "value_4",
          disabled: false
        }
      ];
    }
  },
  async created() {},
  async mounted() {},
  methods: {
    AAA() {},
    isCheck(v) {
      this.check = v;
    },
    isCheck2(v) {
      this.check2 = v;
    },
    updateRadio(checkedValue) {
      this.radioValue = checkedValue;
    },
    updateRadio2(v) {
      this.radioValue2 = v;
    },
    onKey() {
      // console.log('onKey')
    },
    toblur() {
      // console.log('toblur')
    },
    selectClick(e) {
      this.selectDefault = e;
    },
    addProgress(flag) {
      flag ? this.progressValue++ : this.progressValue--;
    },
    deleteFilter(i) {
      // console.log(i)
      if (i == "all") {
        this.filterList = [];
      } else {
        this.filterList.splice(i, 1);
      }
    },
    categorySearch(e) {
      this.selectCheckBoxValue = e;
    },
    deleteSelectCheckBoxValue(i) {
      console.log(i);
      if (i == "all") {
        this.selectCheckBoxValue = [];
      } else {
        this.selectCheckBoxValue.splice(i, 1);
      }
    },
    async changePage(page) {
      this.meta.current = page;
    },
    changeStep(e) {
      // console.log(e)
      this.currentStep = e.index;
    },
    changeTime(e) {
      this.valueDatePicker = e;
    },
    onPagination() {
      this.meta.current = 1;
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.titleDemo {
  @apply text-main-0 text-24 font-600 my-40 relative;
  &:after {
    content: " ";
    @apply inline-block w-60 h-2 bg-main-0 absolute left-0;
    bottom: -2px;
  }
}

.sub {
  @apply text-main-0 text-14 font-600 my-20 relative;
}
</style>
